import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index"

export default {
    data() {
        return {
            titles: [
                { title: this.$t('GovernmentRegulation.speedOverCountVlaue'), number: '0' },
                { title: this.$t('GovernmentRegulation.overloadCountVlaue'), number: '0' },
                { title: this.$t('GovernmentRegulation.safeBeltVlaue'), number: '0' },
                { title: this.$t('GovernmentRegulation.collisionCountVlaue'), number: '0' },
                { title: this.$t('GovernmentRegulation.leaveFenceCountVlaue'), number: '0' }
            ],
            line: ["line5", "line3", "line2", "line1", "line6"],
            oneDown: ["oneDown5", "oneDown3", "oneDown2", "oneDown1", "oneDown6"],

            optionLine: {},
            lineLoading: false,
            isLine: true,

            optionPie: {},
            pieLoading: false,
            speedOverCount: '',
            overloadCount: '',
            outPositionCount: '',
            collisionCount: '',
            leaveFenceCount: '',

            formInline: {
                companyName: '',
            },
            height: '500',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            
            columns: [
                {
                    prop: "companyName",
                    label: this.$t('common.companyName'),
                    align: "center",
                },
                {
                    id: "overloadNum",
                    prop: "overloadCount",
                    label: this.$t('GovernmentRegulation.overloadCountVlaue'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            on: {
                                click: () => {
                                    this.cellClick(params)
                                }
                            }
                        }, params.row.overloadCount)
                    }
                },
                {
                    id: "speedOverNum",
                    prop: "speedOverCount",
                    label: this.$t('GovernmentRegulation.speedOverCountVlaue'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            on: {
                                click: () => {
                                    this.cellClick(params)
                                }
                            }
                        }, params.row.speedOverCount)
                    }

                },
                {
                    id: "collisionNum",
                    prop: "collisionCount",
                    label: this.$t('GovernmentRegulation.collisionCountVlaue'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            on: {
                                click: () => {
                                    this.cellClick(params)
                                }
                            }
                        }, params.row.collisionCount)
                    }
                },
                {
                    id: "leaveFenceNum",
                    prop: "leaveFenceCount",
                    label: this.$t('GovernmentRegulation.leaveFenceCountVlaue'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            on: {
                                click: () => {
                                    this.cellClick(params)
                                }
                            }
                        }, params.row.leaveFenceCount)
                    }
                },
                {
                    id: "outPositionNum",
                    prop: "outPositionCount",
                    label: this.$t('GovernmentRegulation.safeBeltVlaue'),
                    align: "center",
                    render: (h, params) => {
                        return h('el-tag', {
                            on: {
                                click: () => {
                                    this.cellClick(params)
                                }
                            }
                        }, params.row.outPositionCount)
                    }
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 

            dialogOperateFormVisible: false,
            formTable: {
                carId: '',
                plateNum: '',
                driverName: ''
            },
            operatesList: [],
            operatesHeight: '350px',
            allOption: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: false, 
                serialNumber: true, 
            },
            allColumns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "terminalId",
                    label: this.$t('common.terminalId'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "driverNum",
                    label: this.$t('common.driverNum'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "driverName",
                    label: this.$t('common.driverName'),
                    align: "center",
                    width: "140px"
                },
                {
                    prop: "eventMessage",
                    label: this.$t('GovernmentRegulation.eventMessage'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "startTime",
                    label: this.$t('common.starDate'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "endTime",
                    label: this.$t('common.endDate'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "eventInterval",
                    label: this.$t('GovernmentRegulation.eventInterval'),
                    align: "center",
                    width: "120px"
                },
            ],
            allOperates: {
                width: 100,
                fixed: "right",
                list: [
                    
                ],
            },
            OperatesCurrentPage: 1,
            OperatesPageSize: 10,
            OperatesTotal: 1,
            companyNum: '',
            eventNum: ''
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination,
    },
    mounted() {
        this.getData()
        this.getViolationPeriod()
        this.getMonthOrderList()
    },
    methods: {
        getData() {
            this.pieLoading = true
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
                selectType: 0
            }
            this.$store.dispatch('SecureAnalysis/GET_GETSAFETYSURVEY', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.titles[0].number = String(res.data.data.speedOverCount)
                        this.titles[1].number = String(res.data.data.overloadCount)
                        this.titles[2].number = String(res.data.data.outPositionCount)
                        this.titles[3].number = String(res.data.data.collisionCount)
                        this.titles[4].number = String(res.data.data.leaveFenceCount)
                        this.speedOverCount = String(res.data.data.speedOverCount)
                        this.overloadCount = String(res.data.data.overloadCount)
                        this.outPositionCount = String(res.data.data.outPositionCount)
                        this.collisionCount = String(res.data.data.collisionCount)
                        this.leaveFenceCount = String(res.data.data.leaveFenceCount)
                        this.ViolationPie(this.speedOverCount, this.overloadCount, this.outPositionCount, this.collisionCount, this.leaveFenceCount)
                    }
                }
                this.pieLoading = false
            }).catch(err => {
                this.pieLoading = false
            })
        },
        getViolationPeriod() {
            this.lineLoading = true
            let dateArr = []; 
            let overLoad = []; 
            let speedOver = []; 
            let collision = []; 
            let leaveFence = [];
            let outPosition = [];
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
                selectType: 0
            }
            this.$store.dispatch("SecureAnalysis/GET_GETVIOLATIONTREND", param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        if (res.data.data.length > 0) {
                            this.isLine = true
                            res.data.data.map((item, index) => {
                                dateArr.push(item.date)
                                overLoad.push(item.overloadCount)
                                speedOver.push(item.speedOverCount)
                                collision.push(item.collisionCount)
                                leaveFence.push(item.leaveFenceCount)
                                outPosition.push(item.outPositionCount)
                                this.ViolationLine(dateArr, overLoad, speedOver, collision, leaveFence, outPosition)
                            })
                        } else {
                            this.isLine = false
                        }
                    }
                }
                this.lineLoading = false
            }).catch(err => {
                this.lineLoading = false
            })
        },
        ViolationLine(dateArr, overLoad, speedOver, collision, leaveFence, outPosition) {
            let option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    left: 'center',
                    data: [this.$t('GovernmentRegulation.overloadCount'), this.$t('GovernmentRegulation.speedOverCount'), this.$t('GovernmentRegulation.safeBelt'), this.$t('GovernmentRegulation.collisionCount'), this.$t('GovernmentRegulation.leaveFenceCount')],
                    top: '10',
                    textStyle: {
                        color: '#fff'
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff',
                        }
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#fff',
                        }
                    },
                    splitLine: { show: false },
                    data: dateArr
                },
                grid: {
                    left: '1%',
                    right: '2%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [{
                    type: 'value',
                    name: this.$t('GovernmentRegulation.value'),
                    nameTextStyle: {
                        color: "white",
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ['rgba(173,177,195,.1)'],
                            type: 'dashed'
                        }
                    },
                    axisLabel: {
                        formatter: '{value}',
                        color: '#fff'
                    }
                }],
                series: [
                    {
                        name: this.$t('GovernmentRegulation.overloadCount'),
                        type: 'line',
                        smooth: true,
                        color: '#48e1f9',
                        data: overLoad
                    },
                    {
                        name: this.$t('GovernmentRegulation.speedOverCount'),
                        type: 'line',
                        smooth: true,
                        color: '#409eff',
                        data: speedOver,
                    },
                    {
                        name: this.$t('GovernmentRegulation.safeBelt'),
                        type: 'line',
                        smooth: true,
                        color: '#44F09D',
                        data: outPosition,
                    },
                    {
                        name: this.$t('GovernmentRegulation.collisionCount'),
                        type: 'line',
                        smooth: true,
                        color: '#d860a1',
                        data: collision,
                    },
                    {
                        name: this.$t('GovernmentRegulation.leaveFenceCount'),
                        type: 'line',
                        smooth: true,
                        color: '#fc5b62',
                        data: leaveFence,
                    }
                ]
            }
            this.optionLine = option
        },
        down() {
            let jurisdictionNum = sessionStorage.getItem("jurisdictionNum")
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportViolationTrend?jurisdictionNum=${jurisdictionNum}&selectType=${0}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportViolationTrend?jurisdictionNum=${jurisdictionNum}&selectType=${0}`
                    location.href = url
                }
            }
        },

        ViolationPie(speedOverCount, overloadCount, outPositionCount, collisionCount, leaveFenceCount) {
            let option = {
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    left: 'center',
                    top: '2%',
                    itemWidth: 10,   
                    itemHeight: 10,  
                    itemGap: 20,
                    textStyle: {
                        color: '#fff'
                    },
                    data: [this.$t('GovernmentRegulation.overloadCount'), this.$t('GovernmentRegulation.speedOverCount'), this.$t('GovernmentRegulation.safeBelt'), this.$t('GovernmentRegulation.collisionCount'), this.$t('GovernmentRegulation.leaveFenceCount')]
                },
                series: [
                    {
                        name: this.$t('common.number'),
                        type: 'pie',
                        radius: ['45%', '65%'],
                        center: ['50%', '55%'],
                        data: [
                            { value: overloadCount, name: this.$t('GovernmentRegulation.overloadCount') },
                            { value: speedOverCount, name: this.$t('GovernmentRegulation.speedOverCount') },
                            { value: outPositionCount, name: this.$t('GovernmentRegulation.safeBelt') },
                            { value: collisionCount, name: this.$t('GovernmentRegulation.collisionCount') },
                            { value: leaveFenceCount, name: this.$t('GovernmentRegulation.leaveFenceCount') },
                        ],
                        label: {
                            color: '#fff'
                        },
                        color: ['#48e1f9', '#409eff', '#44F09D', '#d860a1', '#fc5b62'],
                    }
                ]
            }
            this.optionPie = option
        },

        getMonthOrderList() {
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
                selectType: 0,
                companyName: this.formInline.companyName,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            };
            this.$store.dispatch('SecureAnalysis/GET_GETVIOLATIONANALYSIS', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getMonthOrderList()
        },
        onClear() {
            this.formInline.companyName = ''
            this.getMonthOrderList()
        },
        downCar() {
            let jurisdictionNum = sessionStorage.getItem("jurisdictionNum")
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportViolationAnalysis?jurisdictionNum=${jurisdictionNum}&selectType=${0}&companyName=${this.formInline.companyName}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportViolationAnalysis?jurisdictionNum=${jurisdictionNum}&selectType=${0}&companyName=${this.formInline.companyName}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getMonthOrderList()
        },

        cellClick(val) {
            this.dialogOperateFormVisible = true
            this.companyNum = val.row.companyNum
            this.eventNum = val.column.id
            this.getOperateList()
        },
        getOperateList() {
            let param = {
                jurisdictionNum: sessionStorage.getItem("jurisdictionNum"),
                selectType: 0,
                companyNum: this.companyNum,
                eventNum: this.eventNum,
                carId: this.formTable.carId,
                plateNum: this.formTable.plateNum,
                driverName: this.formTable.driverName,
                pageNum: this.OperatesCurrentPage,
                pageSize: this.OperatesPageSize,
            }
            this.$store.dispatch('SecureAnalysis/GET_GETCARVIOLATIONDETAIL', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.operatesList = res.data.data.list
                        this.$refs.OperatesPage.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        Search() {
            this.OperatesCurrentPage = 1
            this.getOperateList()
        },
        Clear() {
            this.formTable = {
                carId: '',
                plateNum: '',
                driverName: ''
            }
            this.getOperateList()
        },
        closeOperateDia() {
            this.dialogOperateFormVisible = false
        },
        changeOperatesSize(item) {
            this.OperatesPageSize = item.pageSize
            this.OperatesCurrentPage = item.pageNum
            this.getOperateList()
        },
        downOperate() { 
            let jurisdictionNum = sessionStorage.getItem("jurisdictionNum")
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportCarViolationDetail?jurisdictionNum=${jurisdictionNum}&selectType=${0}&companyName=${this.companyNum}&eventNum=${this.eventNum}&carId=${this.formTable.carId}&plateNum=${this.formTable.plateNum}&driverName=${this.formTable.driverName}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportCarViolationDetail?jurisdictionNum=${jurisdictionNum}&selectType=${0}&companyName=${this.companyNum}&eventNum=${this.eventNum}&carId=${this.formTable.carId}&plateNum=${this.formTable.plateNum}&driverName=${this.formTable.driverName}`
                    location.href = url
                }
            }
        },

    }
}
